// extracted by mini-css-extract-plugin
module.exports = {"save_cancel":"SaveCancelBtn_save_cancel__2skwe","cancel":"SaveCancelBtn_cancel__2G1a2","save":"SaveCancelBtn_save__HHsVO"};